export default __webpack_public_path__ + "static/media/7UM516.18b9dae2.jpg";